import type { Modal } from 'hooks/useModal';
import { Link, NakedButton } from '@qga/roo-ui/components';
import { CONTACT_US_URL, CUSTOMER_SUPPORT_HOTLINE_AU, CUSTOMER_SUPPORT_HOTLINE_INTL } from 'config/constants';
import * as track from 'lib/gaTracking/crossPageEvents';
import { openLiveChat } from 'lib/liveChat/actions';
import TelLink from 'components/TelLink';

const onClickLiveChat = () => {
  track.invoiceDownloadFailedModalLinkSelected('live chat');
  openLiveChat();
};

export const downloadInvoiceErrorModalProps: Modal = {
  variant: 'error',
  header: 'Download failed',
  body: (
    <>
      Receipts temporarily unavailable, please refer to your confirmation email or contact customer service via{' '}
      <Link as={NakedButton} onClick={onClickLiveChat} underline>
        live chat
      </Link>
      ,{' '}
      <Link target="_blank" href={CONTACT_US_URL} onClick={() => track.invoiceDownloadFailedModalLinkSelected('email')} underline>
        email
      </Link>
      , or call{' '}
      <TelLink
        number={CUSTOMER_SUPPORT_HOTLINE_AU}
        color="greys.steel"
        underline
        onClick={() => track.invoiceDownloadFailedModalLinkSelected('call customer support')}
      />{' '}
      (outside Australia:{' '}
      <TelLink
        number={CUSTOMER_SUPPORT_HOTLINE_INTL}
        color="greys.steel"
        underline
        onClick={() => track.invoiceDownloadFailedModalLinkSelected('call international customer support')}
      />
      )
    </>
  ),
};
